import { FoodId } from '@/types/Food.types';

export const foodI18n: { [key in FoodId]: string } = {
  almond: 'almonds',
  apple: 'apples',
  avocado: 'avocados',
  banana: 'bananas',
  beet: 'beets',
  'black-bean': 'black beans',
  blueberry: 'blueberries',
  'bell-pepper': 'bell pepper',
  'brazil-nut': 'brazil nuts',
  broccoli: 'broccoli',
  'brown-rice': 'brown rice',
  buckwheat: 'buckwheat',
  bulgur: 'bulgur',
  carrot: 'carrots',
  cashew: 'cashews',
  cauliflower: 'cauliflower',
  celeriac: 'celeriac',
  celery: 'celery',
  chestnut: 'chestnuts',
  chia: 'chia seeds',
  chickpea: 'chickpeas',
  'chinese-cabbage': 'chinese cabbage',
  coconut: 'coconut',
  corn: 'corn',
  couscous: 'couscous',
  cucumber: 'cucumber',
  date: 'dates',
  fig: 'figs',
  flaxseed: 'flaxseed',
  garlic: 'garlic',
  grape: 'grapes',
  'green-cabbage': 'green cabbage',
  hazelnut: 'hazelnuts',
  'hemp-seed': 'hemp seeds',
  kale: 'kale',
  'kidney-bean': 'kidney beans',
  kiwi: 'kiwi',
  lemon: 'lemons',
  lentil: 'lentils',
  lettuce: 'lettuce',
  macadamia: 'macadamia',
  mango: 'mangos',
  millet: 'millet',
  oat: 'oats',
  onion: 'onions',
  orange: 'oranges',
  papaya: 'papaya',
  peach: 'peaches',
  peanut: 'peanuts',
  pecan: 'pecans',
  'pigeon-pea': 'pigeon peas',
  pineapple: 'pineapple',
  'pine-nut': 'pine nuts',
  pistachio: 'pistachios',
  'poppy-seed': 'poppy seeds',
  potato: 'potato',
  'pumpkin-seed': 'pumpkin seeds',
  'red-cabbage': 'red cabbage',
  quinoa: 'quinoa',
  'sesame-seed': 'sesame seeds',
  spinach: 'spinach',
  soybean: 'soybeans',
  strawberry: 'strawberries',
  'sunflower-seed': 'sunflower seeds',
  'sweet-potato': 'sweet potato',
  tomato: 'tomatoes',
  walnut: 'walnuts',
  watermelon: 'watermelon',
  'white-mushroom': 'white mushrooms',
  'white-rice': 'white rice',
  'wild-rice': 'wild rice',
};
